import { OrganizationRoutes } from '../constants/routes'

export default defineNuxtRouteMiddleware(async () => {
  const user = await getCurrentUser()

  if (user) {
    return navigateTo(getOrganizationRoutePath(OrganizationRoutes.Base))
  }
})
